import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import _ from 'lodash'

import AnalyticsManager, { PageEventsTypes } from '@app/analytics/manager'
import { Can } from '@app/context/ability-context'
import SVG from 'react-inlinesvg'
import arrowRight from '@icons/indicator-right'
import pencil from '@icons/pencil/red'
import print from '@icons/print/red'

class Row extends Component {
  render() {
    const { href, group, group: { object } } = this.props
    const students = _.map(_.values(group.students), 'object')
    const count = students.length

    return (
      <Link
        to={href}
        onClick={() => {
          AnalyticsManager.emitPageEvent(PageEventsTypes.OlympReportsClassClick);
        }}
        className="grid__item grid__item--details"
      >
        <div className="w-flex-layout w-flex-layout--columns">
          <h5 className="mb-0">
            { `${I18n.t('groups.form.class')} «${object.name}»` }
          </h5>
          <div className="h-flex-layout h-flex-layout--row-inline">
            <div className="f--md">
              { count }
              &nbsp;
              { I18n.t('teachers.show.student', { count: count }) }
              &nbsp;
            </div>
            <div className="f--md">
              { I18n.t('olympiads.grade', {grade: object.grade }) }
            </div>
          </div>
        </div>
      </Link>
    )
  }
}

Row.propTypes = {
  group: PropTypes.object.isRequired,
  href: PropTypes.string.isRequired
}

export default Row
